import { Link, useSearchParams } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";

export default function ThankYou() {
  const [params] = useSearchParams();
  const id = params.get("id");
  const orderId = params.get("order");
  const isOrder = !!orderId;
  useSeo({
    title: isOrder
      ? "Order received · Henry Miller Museum"
      : "Request received · Henry Miller Museum",
    description: isOrder
      ? "Your donation order has been received."
      : "Your group visit request has been received.",
  });
  return (
    <div className="max-w-2xl mx-auto px-5 py-20">
      <div className="card p-10 text-center">
        <div className="section-eyebrow justify-center">
          {isOrder ? "Order received" : "Request received"}
        </div>
        <h1 className="font-serif text-3xl mt-1 mb-2">Thank you</h1>
        <div className="rule-gold mx-auto" />
        {isOrder ? (
          <p className="text-museum-muted leading-relaxed mt-4">
            We've recorded your donation order
            {orderId ? <> (<span className="text-museum-ink font-medium">#{orderId}</span>)</> : null}.
            A confirmation has been sent to your email. Jennifer Edgar at IBEW Local 1 will
            follow up within five business days to confirm details and arrange payment.
          </p>
        ) : (
          <p className="text-museum-muted leading-relaxed mt-4">
            We've recorded your group visit request
            {id ? <> (<span className="text-museum-ink font-medium">#{id}</span>)</> : null}.
            A confirmation has been sent to your email. Our staff typically respond within five
            business days.
          </p>
        )}
        <p className="mt-8">
          <Link to={isOrder ? "/donate" : "/"} className="btn-secondary">
            ← Back to {isOrder ? "donation page" : "the form"}
          </Link>
        </p>
      </div>
    </div>
  );
}
